import { render, staticRenderFns } from "./MinusBox.vue?vue&type=template&id=d90829ce"
import script from "./MinusBox.vue?vue&type=script&lang=js"
export * from "./MinusBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports